import { getBackendUrl } from "@Utils";
import type { GetCesiumDataResponse } from "@ServerTypes/accounts/accounts.schema";
import { useTranslation } from "@i18n";
import { useEffect, useState } from "react";
import axiosWrapper from "@AxiosWrapper";

(window as any).CESIUM_BASE_URL = "/static/js/Cesium";

function GeoSpatial() {
  const { t } = useTranslation();
  const [url, setUrl] = useState<string | undefined>(undefined);
  const init = async () => {
    const response = await axiosWrapper.get<GetCesiumDataResponse>(`${getBackendUrl()}/accounts/cesium/getCesiumData`);
    setUrl(response.data.data);
  };

  useEffect(() => {
    init();
  }, []);

  return <iframe title={t("cube-geo")} className="w-full h-full absolute top-7" src={url} />;
}

export default GeoSpatial;
